import {Toast} from 'primereact/toast'
import {useCallback, useEffect, useRef} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {notificationEvent} from './NotificationService'
import { severityNotification } from './NotificationConstant'


const Notification = () => {
    const toastRef = useRef(null)
    const {translateCommons} = TranslateUtils()
    const hideNotification = useCallback(() => {
        toastRef?.current?.clear()
    }, [])
    const showNotification = useCallback(
        ({severity, detail}) => {
            if (!severity) {
                return
            }

            let summary = ''

            switch (severity) {
                case severityNotification.success:
                    summary = 'Success'
                    break
                case severityNotification.info:
                    summary = 'Information'
                    break
                case severityNotification.warn:
                    summary = 'Warning'
                    break
                case severityNotification.error:
                    summary = 'Error'
                    break
                default:
                    summary = 'Success'
                    break
            }
            let item = {
                severity,
                summary: translateCommons(summary),
                detail: translateCommons(detail),
            }

            toastRef?.current?.show(item)
        },
        //không gắn translateCommons
        [],
    )

    useEffect(() => {
        notificationEvent.on('NOTIFY', (severity, detail) =>
            showNotification(severity, detail),
        )
        notificationEvent.on('HIDE-NOTIFICATION', hideNotification)

        return () => {
            notificationEvent.removeListener('NOTIFY', hideNotification)
            notificationEvent.removeListener(
                'HIDE-NOTIFICATION',
                hideNotification,
            )
        }
    }, [hideNotification, showNotification])

    return (
        <Toast
            id="globalToast"
            ref={toastRef}
            baseZIndex={4070}
            position="bottom-right"
        />
    )
}

export default Notification
